(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-accordion-01"] && !Shopify.designMode) return;
  try {
    
  class YGAccordion01 extends HTMLElement {
    #sectionEl;

    constructor() {
      super();
      this.currentStepIndex = 0;
      this.mobileSwiper = null;
      this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
      this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this.#sectionEl) return this.#sectionEl;
      this.#sectionEl = {
        accordionList: this.querySelectorAll('.yg-process-steps-item'),
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        desktopControls: this.querySelectorAll('.yg-process-steps-media'),
        mobileControls: this.querySelectorAll('.yg-process-steps-content-media'),
        mobileSwiperElement: this.querySelector('.yg-accordion-mobile-swiper'),
        mobileSwiperSlides: this.querySelectorAll('.yg-accordion-mobile-slide')
      };

      return this.#sectionEl;
    }

    get isMobileSwiperMode() {
      return window.innerWidth <= 699 && this.dataset.mobileSwiperEnabled === 'true';
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.addEventListener('YG:progress-end', this.handleProgressEnd);
      window.addEventListener('resize', this.handleResize);
      this.bindMobileSwiper();

      if (this.isMobileSwiperMode) {
        this.pauseAccordionVideos();
        this.playMobileSwiperVideo();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.removeEventListener('YG:progress-end', this.handleProgressEnd);
      window.removeEventListener('resize', this.handleResize);
      this.unbindMobileSwiper();
      this.pauseAllVideos();
    }

    bindMobileSwiper(retryCount = 12) {
      if (this.dataset.mobileSwiperEnabled !== 'true') {
        return;
      }

      const swiper = this.sectionElements.mobileSwiperElement?.swiper;

      if (!swiper) {
        if (retryCount > 0) {
          window.setTimeout(() => this.bindMobileSwiper(retryCount - 1), 120);
        }
        return;
      }

      if (this.mobileSwiper === swiper) {
        return;
      }

      this.unbindMobileSwiper();
      this.mobileSwiper = swiper;
      this.mobileSwiper.on('slideChange', this.handleMobileSlideChange);
      this.handleMobileSlideChange();
    }

    unbindMobileSwiper() {
      if (this.mobileSwiper?.off) {
        this.mobileSwiper.off('slideChange', this.handleMobileSlideChange);
      }

      this.mobileSwiper = null;
    }

    handleDropdownOpen(event) {
      const id = event.detail?.id;

      if (this.isMobileSwiperMode || !id) {
        return;
      }

      this.currentStep(id);
    }

    handleProgressEnd(event) {
      const id = event.detail?.id;

      if (this.isMobileSwiperMode || !id) {
        return;
      }

      this.nextStep(id);
    }

    handleMobileSlideChange() {
      if (!this.isMobileSwiperMode || !this.mobileSwiper) {
        return;
      }

      this.currentStepIndex = typeof this.mobileSwiper.realIndex === 'number'
        ? this.mobileSwiper.realIndex
        : this.mobileSwiper.activeIndex;

      this.playMobileSwiperVideo(this.currentStepIndex);
    }

    handleResize() {
      if (this.isMobileSwiperMode) {
        this.bindMobileSwiper();
        this.pauseAccordionVideos();
        this.playMobileSwiperVideo();
        return;
      }

      this.pauseMobileSwiperVideos();
    }

    nextStep(id) {
      this.sectionElements.accordionList.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.sectionElements.accordionList.length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });

      if (!this.isCurrentStep(id)) {
        return;
      }
      this.sectionElements.accordionList[this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.sectionElements.accordionList.forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    getEffectiveId(id) {
      let isMobile = window.innerWidth <= 699;
      if (isMobile) {
        return id.replace('steps-item-', 'steps-item-mobile-');
      }
      return id;
    }

    setActiveControl(id) {
      this.sectionElements.desktopControls.forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.sectionElements.progressBars?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

      controlGroups.forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAccordionVideos() {
      const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

      controlGroups.forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl && typeof videoEl.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    pauseMobileSwiperVideos() {
      this.sectionElements.mobileSwiperSlides.forEach((slide) => {
        const videoEl = slide.querySelector('yg-video');
        if (videoEl && typeof videoEl.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    pauseAllVideos() {
      this.pauseAccordionVideos();
      this.pauseMobileSwiperVideos();
    }

    playVideo(id) {
      let effectiveId = this.getEffectiveId(id);
      this.pauseAccordionVideos();
      const videoEl = this.getVideoById(effectiveId);
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }

    playMobileSwiperVideo(index) {
      if (!this.isMobileSwiperMode) {
        return;
      }

      const activeIndex = typeof index === 'number'
        ? index
        : typeof this.mobileSwiper?.realIndex === 'number'
          ? this.mobileSwiper.realIndex
          : this.mobileSwiper?.activeIndex || 0;

      this.pauseMobileSwiperVideos();

      const videoEl = this.sectionElements.mobileSwiperSlides[activeIndex]?.querySelector('yg-video');
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-accordion-01')) {
    window.customElements.define('yg-accordion-01', YGAccordion01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
    class YGTabs03 extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
        this.mediaSwiper = null;
        this.contentSwiper = null;
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      get sectionElements() {
        if (this._sectionElements) {
          return this._sectionElements;
        }

        this._sectionElements = {
          tabsTrack: this.querySelector('[data-tabs-track]'),
          tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
          tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
          mediaSwiper: this.querySelector('[data-media-swiper]'),
          contentSwiper: this.querySelector('[data-content-swiper]'),
          contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
        };

        return this._sectionElements;
      }

      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;

        this.sectionElements.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
        window.addEventListener('resize', this.handleResize);

        this.mountSwipers();
      }

      disconnectedCallback() {
        this.sectionElements.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
        window.removeEventListener('resize', this.handleResize);

        if (this.mediaSwiper) {
          this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
          this.mediaSwiper = null;
        }

        if (this.contentSwiper) {
          this.contentSwiper = null;
        }

        this.initialized = false;
      }

      mountSwipers(attempt = 0) {
        const mediaSwiperElement = this.sectionElements.mediaSwiper;
        const contentSwiperElement = this.sectionElements.contentSwiper;

        if (!mediaSwiperElement || !contentSwiperElement) {
          return;
        }

        if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
          if (attempt < 10) {
            window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
          }
          return;
        }

        if (!this.mediaSwiper) {
          this.mediaSwiper = mediaSwiperElement.swiper;
          this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
        }

        if (!this.contentSwiper) {
          this.contentSwiper = contentSwiperElement.swiper;
        }

        this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.contentSwiper.allowTouchMove = false;
        this.contentSwiper.params.allowTouchMove = false;
        this.contentSwiper.params.autoHeight = true;

        this.setActiveState(0, {
          syncSwiper: false,
          scrollBehavior: 'auto',
        });
      }

      handleTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.tabIndex);

        this.setActiveState(index);
      }

      handleTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        const currentIndex = this.activeIndex;
        const lastIndex = this.sectionElements.tabs.length - 1;
        let nextIndex = currentIndex;

        if (event.key == 'ArrowLeft') {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
        } else if (event.key == 'ArrowRight') {
          nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
        } else if (event.key == 'Home') {
          nextIndex = 0;
        } else if (event.key == 'End') {
          nextIndex = lastIndex;
        }

        event.preventDefault();

        const nextTab = this.sectionElements.tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
        }

        this.setActiveState(nextIndex);
      }

      handleMediaSlideChange() {
        const nextIndex = typeof this.mediaSwiper.realIndex === 'number'
          ? this.mediaSwiper.realIndex
          : this.mediaSwiper.activeIndex;

        if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
          this.contentSwiper.slideTo(nextIndex);
        }

        this.setActiveState(nextIndex, {
          syncSwiper: false,
        });
      }

      handleResize() {
        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView('auto');
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }

      isTabsOverflowing() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return false;
        }

        return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
      }

      scrollActiveTabIntoView(behavior = 'smooth') {
        const scrollContainer = this.sectionElements.tabsScrollContainer;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!activeTab || !scrollContainer) {
          return;
        }

        if (this.isTabsOverflowing()) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const itemRect = activeTab.getBoundingClientRect();
          const currentScrollLeft = scrollContainer.scrollLeft;
          const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
          const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
          const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

          if (typeof scrollContainer.scrollTo === 'function') {
            scrollContainer.scrollTo({
              left: nextScrollLeft,
              behavior: behavior,
            });
          } else {
            scrollContainer.scrollLeft = nextScrollLeft;
          }
        }
      }

      updateOverflowState() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return;
        }

        scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
      }

      updateIndicator() {
        const tabsTrack = this.sectionElements.tabsTrack;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!tabsTrack || !activeTab) {
          return;
        }

        tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
        tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
      }

      pauseAllVideos() {
        this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          }
        });
      }

      playActiveVideo() {
        this.pauseAllVideos();

        const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
        const activeVideo = activeSlide?.querySelector('yg-video');

        if (activeVideo && typeof activeVideo.playVideo === 'function') {
          activeVideo.playVideo();
        }
      }

      setActiveState(index, options = {}) {
        const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
        const syncSwiper = options.syncSwiper !== false;
        const scrollBehavior = options.scrollBehavior || 'smooth';

        this.activeIndex = safeIndex;

        if (syncSwiper) {
          if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
            this.mediaSwiper.slideTo(safeIndex);
          }

          if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
            this.contentSwiper.slideTo(safeIndex);
          }
        }

        this.sectionElements.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === safeIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
        });

        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView(scrollBehavior);
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        this.playActiveVideo();

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }
    }

    if (!window.customElements.get('yg-tabs-03')) {
      window.customElements.define('yg-tabs-03', YGTabs03);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGVideoList01 extends HTMLElement {
      constructor() {
        super();
        this.playbackMode = this.getAttribute('data-playback-mode');
        this.slideItems = this.querySelectorAll('.yg-slide-item');
        this.handleClickPlayback = this.handleClickPlayback.bind(this);
      }
      connectedCallback() {
        if (this.playbackMode === 'click') {
          this.addEventListener('click', this.handleClickPlayback, true);
        }

        if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
          this.initHoverPlayback();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClickPlayback, true);
      }

      handleClickPlayback(event) {
        const target = event.target instanceof Element ? event.target : null;
        const playButton = target ? target.closest('.yg-play') : null;
        if (!playButton || !this.contains(playButton)) return;

        const currentVideo = playButton.closest('yg-video');
        if (!currentVideo || !this.contains(currentVideo)) return;

        this.pauseOtherVideos(currentVideo);
      }

      pauseOtherVideos(currentVideo) {
        this.querySelectorAll('yg-video').forEach((videoEl) => {
          if (videoEl === currentVideo || typeof videoEl.pauseVideo !== 'function') return;
          videoEl.pauseVideo();
        });
      }

      initHoverPlayback() {
        this.slideItems.forEach((item) => {
          const videoEl = item.querySelector('yg-video');
          if (!videoEl) return;

          item.addEventListener('mouseenter', () => {
            if (videoEl.playVideo) {
              videoEl.playVideo();
            }
          });

          item.addEventListener('mouseleave', () => {
            if (videoEl.pauseVideo) {
              videoEl.pauseVideo();
            }
          });
        });
      }
    }
    if (!window.customElements.get('yg-video-list-01')) {
      window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList02 extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
          const ygSwiper = this.querySelector('yg-swiper').swiper;
          if (!ygSwiper) return;
          ygSwiper.on('slideChangeTransitionEnd', (e) => {
            this.switchVideoStatus(e)
          });
        }

        switchVideoStatus(e){
          // 从 e 对象中获取当前激活块
          const currentSlide = e.slides[e.activeIndex];
          // 若要获取 block id，假设每个 slide 有 data-block-id 属性
          const currentBlockId = currentSlide ? currentSlide.dataset.blockId : null;
          e.slides.forEach((slide) => {
            const video = slide.querySelector('yg-video');
            if (video && typeof video.pauseVideo === 'function') {
              video.pauseVideo();
            }
          })
          
          const video = currentSlide.querySelector('yg-video');
          if (video && typeof video.playVideo === 'function') {
            video.playVideo();
          }
        }
    }
    if (!window.customElements.get('YGVideoList02')) {
        window.customElements.define('yg-video-list-02',YGVideoList02)
    }
  })

  } catch(e) { console.error(e); }
})();
})();
